@let expanded = store.expandedSg();
@let externalUrl = externalUrlSg();
@let internalUrl = internalUrlSg();

@if (externalUrl) {
  <a
    class="atn-navbar-footer-item"
    [href]="externalUrl"
    target="_blank"
    rel="noopener"
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
} @else if (internalUrl) {
  <a
    class="atn-navbar-footer-item"
    [routerLink]="internalUrl"
  >
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </a>
} @else {
  <div class="atn-navbar-footer-item">
    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
  </div>
}

<ng-template #linkContent>
  <i
    class="atn-navbar-footer-item__icon atn-icon atn-{{ iconSg() }} atn-light"
    [class.atn-navbar-footer-item__icon--centered]="!expanded"
  ></i>
  <div
    class="atn-navbar-footer-item__name"
    [class.atn-navbar-footer-item__name--hidden]="!expanded"
  >
    <span class="atn-navbar-footer-item__name-content">
      {{ nameSg() }}
      @if (suffixIconSg(); as suffixIcon) {
        <i
          class="atn-navbar-footer-item__suffix-icon atn-icon atn-{{
            suffixIcon
          }} atn-light"
        ></i>
      }
    </span>
  </div>
</ng-template>
